/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAttachmentUploadResponseData } from './genericApiResponseAttachmentUploadResponseData';
import type { GenericApiResponseAttachmentUploadResponseMessage } from './genericApiResponseAttachmentUploadResponseMessage';
import type { GenericApiResponseAttachmentUploadResponsePagination } from './genericApiResponseAttachmentUploadResponsePagination';
import type { GenericApiResponseAttachmentUploadResponseError } from './genericApiResponseAttachmentUploadResponseError';

export interface GenericApiResponseAttachmentUploadResponse {
  data?: GenericApiResponseAttachmentUploadResponseData;
  message?: GenericApiResponseAttachmentUploadResponseMessage;
  pagination?: GenericApiResponseAttachmentUploadResponsePagination;
  error?: GenericApiResponseAttachmentUploadResponseError;
  statusCode?: number;
}
